import { Chip } from "@mui/material";
import { formatDate } from "../../../helpers/formatingFunctions";
import UpdateDriverIssuePopup from "../../../components/Recruiting/DriverIssues/UpdateDriverIssuePopup";
import RecruitingDeleteButton from "../../../components/Recruiting/RecruitingDeleteButton/RecruitingDeleteButton";

export const driverIssueTableColumns = [
  {
    field: "dateOfIssueNotification",
    headerName: "Issue Date",
    width: 140,
    valueFormatter: (value: string) => (value ? formatDate(value) : ""),
  },
  {
    field: "driverName",
    headerName: "Driver",
    width: 180,
  },
  {
    field: "phoneNumber",
    headerName: "Phone",
    width: 140,
  },
  {
    field: "truckUnitNumber",
    headerName: "Truck",
    width: 140,
  },
  {
    field: "dispatcherName",
    headerName: "Dispatcher",
    width: 180,
  },
  {
    field: "priority",
    headerName: "Priority",
    width: 130,
  },
  {
    field: "status",
    headerName: "Status",
    width: 130,
    renderCell: (params: any) => {
      const rawStatus = params?.value ?? params?.row?.status;
      const status = String(rawStatus ?? "").trim();
      const normalized = status.toLowerCase();

      const labelMap: Record<string, string> = {
        open: "Open",
        in_progress: "In progress",
        resolved: "Resolved",
        pending_term: "Pending term",
        terminated: "Terminated",
      };

      const color =
        normalized === "resolved"
          ? "success"
          : normalized === "terminated"
            ? "error"
            : normalized === "pending_term"
              ? "warning"
              : normalized === "in_progress"
                ? "info"
                : normalized === "open"
                  ? "warning"
                  : "default";

      return (
        <Chip
          size="small"
          label={labelMap[normalized] ?? status}
          color={color}
          variant={color === "default" ? "outlined" : "filled"}
        />
      );
    },
  },
  {
    field: "contextOfConcern",
    headerName: "Context",
    width: 220,
  },
  {
    field: "concernAwareBy",
    headerName: "Concern Aware By",
    width: 170,
  },
  {
    field: "actionsTaken",
    headerName: "Actions Taken",
    width: 200,
  },
  {
    field: "resolutionDate",
    headerName: "Resolution Date",
    width: 150,
    valueFormatter: (value: string) => (value ? formatDate(value) : ""),
  },
  {
    field: "terminationComments",
    headerName: "Termination Comments",
    width: 200,
  },
  {
    field: "resolutionComments",
    headerName: "Resolution Comments",
    width: 200,
  },
  {
    field: "update",
    headerName: "",
    width: 140,
    renderCell: (params: any) => <UpdateDriverIssuePopup issue={params.row} />,
  },
  {
    field: "delete",
    headerName: "",
    width: 140,
    renderCell: (params: any) => (
      <RecruitingDeleteButton
        id={params.row.id}
        endpoint="recruiting/driver-issue"
        entityLabel="driver issue"
        queryKey={["driverIssues"]}
      />
    ),
  },
];
